import { Box, style } from '@do/walrus';
import { ReactElement } from 'react';

const Title = ({ title }: { title: string }): ReactElement => {
  return (
    <Box mb={style.vars.whitespace.small} display="block">
      <h3>{title}</h3>
    </Box>
  );
};

export default Title;
